import contentfulGql from 'js/lib/contentfulGql';

export const BrowseDomainValueProposition = contentfulGql`#graphql
  fragment BrowseDomainFields on BrowseDomain {
    slug
    name
  }

  fragment BrowseDomainValuePropositionItemFields on BrowseDomainValuePropositionItem {
    icon
    text
  }

  fragment BrowseDomainValuePropositionFields on BrowseDomainValueProposition {
    domain {
      ...BrowseDomainFields
    }
    description
    valuePropositionItemCollection {
      items {
        ...BrowseDomainValuePropositionItemFields
      }
    }
  }

  query BrowseDomainValueProposition($locale: String!, $domainSlug: String!) {
    browseDomainValuePropositionCollection(locale: $locale, where: {domain: {slug: $domainSlug}}) {
      items {
        ...BrowseDomainValuePropositionFields
      }
    }
  }
`;
